import React from 'react'
import { connect } from 'react-redux';
import { change as changeFieldValue, reduxForm } from 'redux-form';
import { formatarReal } from '../../util/numberUtil';
import DetalheEncomenda from './DetalheEncomenda';
import alterarExibicaoEncomenda from '../../actions/encomenda/alterarExibicaoEncomenda';
import buscarEncomenda from '../../actions/encomenda/buscarEncomenda';
import buscarEncomendas from '../../actions/encomenda/buscarEncomendasEmpresa';
import buscarEncomendaItinerario from '../../actions/encomenda/buscarEncomendaItinerario';
import selecionarEncomenda from '../../actions/encomenda/selecionarEncomenda';

export class EncomendaBaixaEntrega extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imagensInformarEntrega: [],
    }
  }

  exibirIcone(encomenda) {
    if (encomenda.exibirDetalhe) {
      return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoEncomenda(encomenda)}>
        &#xE5C7;</i>
    }
    return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoEncomenda(encomenda)}>&#xE5C5;</i>
  }

  exibirBotaoEmbarqueDesembarque(encomenda) {
    if (encomenda.dataHoraEmbarque && !encomenda.dataHoraDesembarque) {
      return <button type="submit" style={{ fontSize: 10 }} data-toggle="modal"
        data-target="#modalConfirmarEmbarqueDesembarqueEncomenda" className="btn btn-sm btn-vermelho"
        onClick={() => this.props.selecionarEncomendaEmbarqueDesembarque(encomenda)}>Desembarcar encomenda</button>
    }
    if (!encomenda.dataHoraEmbarque) {
      return <button type="submit" style={{ fontSize: 10 }} data-toggle="modal"
        data-target="#modalConfirmarEmbarqueDesembarqueEncomenda" className="btn btn-sm btn-verde"
        onClick={() => this.props.selecionarEncomendaEmbarqueDesembarque(encomenda)}>Embarcar encomenda</button>
    }
    if (encomenda.dataHoraDesembarque) {
      return <span>Encomenda desembarcada</span>
    }
  }

  exibirListaEncomendas() {
    const encomenda = this.props.encomenda;
    return (
      <div className="resumo">
        <div className="row align-items-center">
          <div className="col-sm-1" style={{ cursor: 'pointer' }}>
            {this.exibirIcone(encomenda)}
          </div>
          <div className="col-lg-1 col-lg-2">
            {this.exibirBotaoEmbarqueDesembarque(encomenda)}
          </div>
          <div className="col-lg-1 col-md-2">
            <span className="titulo-mobile">N° Pedido&nbsp;</span>{this.props.encomenda.idPedido}
          </div>
          <div className="col-lg-1 col-md-2">
            <span className="titulo-mobile">Vendedor:&nbsp;</span>{this.props.encomenda.nomeVendedor}
          </div>
          <div className="col-lg-1 col-md-2">
            <span className="titulo-mobile">Descrição:&nbsp;</span>{this.props.encomenda.descricaoProduto}
          </div>
          <div className="col-lg-1 col-md-2">
            <span className="titulo-mobile">Nome Remetente&nbsp;</span>{this.props.encomenda.remetente.nome}
          </div>
          <div className="col-xl-1 col-xl-2">
            <span className="titulo-mobile">Data da venda:&nbsp;</span>{this.props.encomenda.dataCriacao}
          </div>
          <div className="col-lg-1 col-md-2">
            <span className="titulo-mobile">Situação:&nbsp;</span>{this.props.encomenda.ultimoHistorico.descricaoSituacao}
          </div>
          <div className="col-lg-1 col-xl-1">
            <span className="titulo-mobile">Valor:&nbsp;</span>{formatarReal(this.props.encomenda.valorTotal)}
          </div>
          <div className="col-md-1">
            <button type="button"
              className="btn-sm btn-laranja"
              style={{ fontSize: 13 }}
              data-toggle="modal"
              data-target="#modalInformarEntregaEncomenda"
              onClick={() => {
                this.props.changeFieldValue('formularioInformarEntregaEncomenda', 'observacao', this.props.encomenda.observacaoEntrega);
                this.props.preencherModalInformarEntregaEncomenda(this.props.encomenda.imagensInformarEntrega)
                this.props.selecionarEncomenda(this.props.encomenda); 
              }}>
              Informar entrega
            </button>
          </div>
        </div>
      </div>
    )
  }

  exibirTabelaEncomendas() {
    const encomenda = this.props.encomenda;
    return (
      <div className="col-12 conteudo-internas">
        <div className="lista-table">
          <div key={encomenda.id}>
            {this.exibirListaEncomendas(encomenda)}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const encomenda = this.props.encomenda;
    return (

      <div className="geral">
        {this.exibirTabelaEncomendas(encomenda)}

        <DetalheEncomenda encomenda={encomenda} />

      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    encomendas: state.encomendas.encomendas,
    empresaSelecionada: state.empresaSelecionada
  });

export default connect(mapStateToProps,
  {
    selecionarEncomenda,
    buscarEncomendaItinerario,
    buscarEncomendas,
    buscarEncomenda,
    changeFieldValue,
    alterarExibicaoEncomenda
  })(reduxForm({
    form: 'formularioCadastroEncomenda'
})(EncomendaBaixaEntrega))